import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { IconStyled } from './styled';

export default function Copyable(props) {
  const { value } = props;
  const [tooltipVisible, setTooltipVisibility] = useState(false);

  const copyToClipboard = () => {
    setTooltipVisibility(true);
    navigator.clipboard.writeText(value);
    setTimeout(() => setTooltipVisibility(false), 1500);
  };

  return (
    <>
      {
        navigator.clipboard && (
          <Tooltip title="Copied!" trigger="click" visible={tooltipVisible}>
              <IconStyled type="copy" onClick={() => copyToClipboard()}/>
          </Tooltip>
        )
      }
    </>
  );
}